import React, { useContext, useState } from "react";
import api, { BASE_URL } from "../../Utils/api";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FiStar } from "react-icons/fi";
import { GlobalContext } from "../../Utils/GlobalContext";
import UserSettingsMenu from "../UserSettings/UserSettingsMenu";
import { useFeedback } from "../Generals/Feedback/FeedbackContext";
import "./PageHeader.css";



function PageHeader({ titulo, path, classificacao, children }) {
  const { toast } = useFeedback();
  const { globalData, setGlobalData, menuType } = useContext(GlobalContext);
  const [saving, setSaving] = useState(false);
  const padrao = globalData?.rota_padrao || null;
  const padraoClassificacao = globalData?.pagina_padrao_classificacao ?? null;
  const isPadrao =
    padrao === path &&
    (classificacao ? padraoClassificacao === classificacao : !padraoClassificacao);

  const handleDefinirPadrao = async () => {
    const userId = globalData?.user_id || localStorage.getItem("user_id");
    if (!userId) return;
    const rota_padrao = isPadrao ? null : path;
    setSaving(true);
    try {
      await api.put(
        `${BASE_URL}/api/usuarios/DefinirRotaPadrao/${userId}`,
        { rota_padrao },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );
      setGlobalData((prev) => ({
        ...prev,
        rota_padrao,
        pagina_padrao_classificacao: rota_padrao && classificacao ? classificacao : null,
      }));
    } catch (err) {
      console.error("Erro ao definir rota padrão:", err);
      toast.error(err.response?.data?.message || "Erro ao definir rota padrão. Tente novamente.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="page-header d-flex align-items-center justify-content-between mb-3 flex-wrap gap-2">
      <div className="page-header-title d-flex align-items-center gap-2">
        <h3 className="mb-0">{titulo}</h3>
        <OverlayTrigger
          placement="bottom"
          overlay={
            <Tooltip id={`padrao-${path}`}>
              {isPadrao
                ? "Remover como página padrão"
                : "Definir como página padrão"}
            </Tooltip>
          }
        >
          <button
            type="button"
            className={`btn btn-link p-1 border-0 ${isPadrao ? "text-warning" : "text-muted"}`}
            onClick={handleDefinirPadrao}
            disabled={saving}
            aria-label={isPadrao ? "Remover como página padrão" : "Definir como página padrão"}
          >
            <FiStar size={20} fill={isPadrao ? "currentColor" : "none"} />
          </button>
        </OverlayTrigger>
      </div>
      <div className="page-header-actions d-flex align-items-center gap-2">
        {children}
        {menuType !== "superior" && <UserSettingsMenu />}
      </div>
    </div>
  );
}

export default PageHeader;
